import { render, staticRenderFns } from "./card-input-receivers.vue?vue&type=template&id=72cee5ca&"
import script from "./card-input-receivers.vue?vue&type=script&lang=js&"
export * from "./card-input-receivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports